import {Pipe, PipeTransform} from "@angular/core";
import {Role} from "iui-iconectiv-lib";

@Pipe({
  name: 'isecroles'
})
export class RolesPipe implements PipeTransform {

  constructor() {
  }

  transform(value: Role[], args?: any): any {
    const rv = value.map(r => r.rolename).join(",");
    return rv;
  }
}
